import { v4 as uuidv4 } from 'uuid';
import { SerializedEditorState } from "lexical";
import { STATIC_URL } from '../../lib/settings';

function base64ToFile(base64: string, filename: string) {
  const arr = base64.split(',');
  const matchResult = arr[0].match(/:(.*?);/);
  const mime = matchResult ? matchResult[1] : '';
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  
  while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

const mimeTypeToFileExtension: { [key: string]: string } = {
  'image/jpeg': '.jpg',
  'image/png': '.png',
  'image/gif': '.gif',
  'image/svg+xml': '.svg'
};

function getImageExtensionFromBase64(base64: string) {
  const match = base64.match(/^data:(image\/.*?);base64,/);
  if (!match) {
      return null;
  }
  const mimeType = match[1];
  return mimeTypeToFileExtension[mimeType] || null;
}


export const replaceImageSrc = (editorState: SerializedEditorState): [SerializedEditorState, FormData] => {
  const data = new FormData();

  const traverse = (node: any) => {
    if (node.src) {
      const { src } = node;
      if (src.startsWith('data:image')) {
        const key = uuidv4();
        const extension = getImageExtensionFromBase64(src) || '';
        const filename = `${key}${extension}`;
        const file = base64ToFile(src, filename);
        data.append('images', file);
        node.src = filename;
      } else if (src.includes(STATIC_URL)) {
        node.src = dehydrateImagePaths(src); 
      }
    }

    if (node.children && node.children.length) {
      node.children.forEach((child: any) => {
        traverse(child);
      });
    }
  };
  traverse(editorState.root);
  return [editorState, data];
};

export const hydrateImagePaths = (content: string) => {
  const re = /"src":\s*"(?!https?:\/\/)(.*?)"/g;
  const matches = content.matchAll(re);
  let newContent = content;
  for (const match of matches) {
    const path = match[1];
    newContent = newContent.replace(path, `${STATIC_URL}/content/${path}`);
  }
  return newContent;
};

const dehydrateImagePaths = (content: string) => {
  const re = new RegExp(`${STATIC_URL}/content/`, 'g');
  return content.replace(re, '');
}